module.exports = __webpack_public_path__ + "img/cashout-active.3b19b55b.svg";